import {
  addSequenceElementToArray,
  getAvailableFormIdsAndFormTableInObjectForm,
  getAvailableGroupIdsAndGroupTableInObjectForm,
  getAvailableQuestionIdsAndQuestionTableInObjectForm,
  getFilteredGroupsUnderForm,
  removeNodesAndUndoLastAction,
  updateGroupsOrderAndStateAsPerOperations,
  updateGroupStateAsPerGroupsOrder,
  updateLocationStateAsPerLocationsOrder,
  updateOperationNodesOrderAndNodeStateAsPerGroups,
  updateBuildingAsPerBuildingsOrder,
  createOperationNodeId,
  createOperationGroupId,
  intersection,
  addQuestionsToOtherGroupFunc,
  undoAddQuestionsToOtherGroupFunc,
} from "./hwlHelper";

import {
  getBrokerInformation,
  retrieveBrokerageImg,
  retrieveBrokerforClient,
} from "../../store/broker";
import translations from "../../utils/translations";
import { useDispatch, useSelector } from "react-redux";

const _ = require("lodash");
export const getCalculateVerticalIdFromProspectDoc = (prospectdoc) => {
  return prospectdoc?.answers?.calculatedverticalid;
};

export const getOperationListProspectDoc = (prospectdoc) => {
  return prospectdoc.answers.operations.list;
};

export const getCoverIdOfPrice = () => 3;

export const premium = () => 206;
export const insurerFees = () => 4;
export const brokerFees = () => 207;
export const premiumAndFees = () => 3;
export const commissionRate = () => 208;

export const getCoverIdForCoverageLevel = () => 5; // this is covermatch
export const getCoverIdForQuoteyScore = () => 6;
export const getCoverIdForExpiryDate = () => 210;

export const getCoverIdForInsurerResponse = () => 1;
export const getCoverIdForComments = () => 2;

export const TotalNumberOfComparisonInsurerPDFCanHandle = 3;

export const MASTERGROUP = "mastergroup";
export const OPERATION = "operation";
export const LOCATION = "location";

// questionFlowUserMode
export const BROKER = "broker";
export const CLIENT = "client";
export const INSURER = "insurer";

// question types
export const SIMPLESTRING = "simplestring";
export const YESNO = "yesno";
export const SINGLESELECT = "singleselect";
export const PERCENTAGE = "percentage";
export const MULTISELECT = "multiselect";
export const DATE = "date";
export const EMAIL = "email";
export const NUMBER = "number";
export const CURRENCY = "currency";
export const CONTACT = "contact";
export const SINGLESELECTPLATINUM = "singleselectplatinum";
export const MULTISELECTPLATINUM = "multiselectplatinum";
export const YEAR = "year";
export const ADDRESS = "address";
export const LARGESTRING = "largestring";
export const MESSAGE = "message";
export const MULTISTRING = "multistring";
export const MULTITEXT = "multitext";
export const SCHEDULE = "schedule";
export const DOCUPLOAD = "documentupload";
export const OPERATIONTABLE = "operationtable";
// not implemented yet question types
export const DATERANGE = "daterange";

// action types for questions
export const ADDQUESTIONS = "addQuestions";
export const ADDGROUPS = "addGroups";
export const ADDFORMS = "addForms";
export const ADDQUESTIONSTOOTHERGROUP = "addQuestionsToOtherGroup";
export const ADDGROUPSTOOTHERFORM = "addGroupsToOtherForm";
export const ADDQUESTIONSTOMULTIPLEGROUPS = "addQuestionsToMultipleGroups";

export const DEFAULT_SELECTED_PRODUCT_CODE = "PACKAGE";

export const OTHER_OPERATION_TEXT_EN = "Operations Zoom";
export const OTHER_OPERATION_TEXT_FR = "Operations Zoom";
export const LAST_GROUPID_OF_EXTRA_OPERATION_FORM = "zzz";

// some hardcoded answers
export const YES = "Yes";
export const NO = "No";

//#region Send to Client Configure
// let BrokerInfo = useSelector(getBrokerInformation);
// const languagepreference = BrokerInfo.information.languagepreference;
// translations[languagepreference].noRecommendation;
export const DEFAULT_SELECTED_OPTION = {
  id: "NOSELECTION",
  text: "No recommendation at this stage",
  frText: "Aucune recommandation à ce stade",
};

/**
 * Retrieve the translation for a given key and language.
 * If the translation or language is not found, return the English default.
 * Supports dynamic content with replacements object.
 *
 * @param {string} langPref - Language preference ('en', 'fr', etc.)
 * @param {string} key - Translation key
 * @param {Object} [replacements={}] - Object containing dynamic replacements
 * @returns {string} - Translated string with replacements applied
 */
export function getTranslation(langPref, key, replacements = {}) {
  // Attempt to get the translation dictionary for the selected language
  const langTranslations = translations[langPref] || translations["en"];

  // Get the translated string
  let text = langTranslations[key] || translations["en"][key] || "";

  // If there are dynamic placeholders, replace them
  for (const [placeholder, value] of Object.entries(replacements)) {
    const regex = new RegExp(`{${placeholder}}`, "g");
    text = text.replace(regex, value);
  }
  return text;
}

/**
 * Returns the default selected option object with translated text.
 *
 * @param {string} langPref - Language preference ('en', 'fr', etc.)
 * @returns {Object} - Object containing id and translated text
 */
export function getDefaultSelectedOption(langPref = "en") {
  return {
    id: "NOSELECTION",
    text: getTranslation(langPref, "defaultSelectedOptionText"),
  };
}

export const EMPTY_COVER_ROW_DETAILS = {
  cover: null,
  reason: null,
};
//#endregion

//#region Question Screen
export const PossibleScheduleInputType = {
  currency: "currency",
  simplestring: "simplestring",
  number: "number",
};

export const PossibleArrayTypesForFormGroupNodeArray = {
  form: "form",
  group: "group",
  node: "node",
  locationgroup: "locationgroup",
  location: "location",
};

export const undoLastActionsRescursively = ({ qf, node, demandedActions }) => {
  // demandedActions is added here as one of the form-remove-policy rule is this:
  // If the demanadedActions has ADDFORMS = ["e_9100"] and the lastActions contain
  // ADDFORMS = ["e_9100", "e_abcd"], then the undoing nullifies to only undoing ADDFORMS = ["e_abcd"].
  // This way remvoing a particular form and adding the same one can be avoided. This saves users already answered values in the form.
  const { lastActions, formtype, formid, id, locationid, buildingid } = node;

  if (!_.isEmpty(lastActions)) {
    for (let action in lastActions) {
      //#region undoing ADDQUESTIONS
      if (action === ADDQUESTIONS) {
        // remove questions which is in the payload
        let questionids = lastActions[action];
        let nodeids = convertQuestionIdsToNodeIdsAsPerForm({
          questionids,
          formtype,
          locationid,
          buildingid,
        });
        qf = FormProperties({ formtype }).removeQuestions({
          questionids,
          nodeids,
          node,
          qf: { ...qf },
        });
      }
      //#endregion

      //#region  undoing ADDQUESTIONSTOOTHERGROUP
      if (action === ADDQUESTIONSTOOTHERGROUP) {
        // remove questions which is in the payload
        let lastActionObject = lastActions[action];

        qf = undoAddQuestionsToOtherGroupFunc({
          lastActionObject,
          formid,
          qf: { ...qf },
          node,
          locationid,
          convertQuestionIdsToNodeIdsAsPerForm,
          FormProperties,
          buildingid,
        });
      }
      //#endregion

      //#region  undoing ADDQUESTIONSTOMULITPLEGROUPS
      if (action === ADDQUESTIONSTOMULTIPLEGROUPS) {
        // remove questions which is in the payload
        const lastActionObjects = lastActions[action];

        if (!_.isEmpty(lastActionObjects)) {
          for (let i = 0; i < lastActionObjects.length; i++) {
            let lastActionObject = lastActionObjects[i];
            qf = undoAddQuestionsToOtherGroupFunc({
              lastActionObject,
              formid,
              qf: { ...qf },
              node,
              locationid,
              convertQuestionIdsToNodeIdsAsPerForm,
              FormProperties,
              buildingid,
            });
          }
        }
      }
      //#endregion

      //#region  undoing ADDGROUPS

      if (action === ADDGROUPS) {
        // remove groups which is in the payload
        let groupids = lastActions[action];

        qf = FormProperties({ formtype }).removeGroups({
          groupids,
          node,
          qf: { ...qf },
        });
      }
      //#endregion

      //#region  undoing ADDGROUPSTOOTHERFORM
      if (action === ADDGROUPSTOOTHERFORM) {
        // remove groups which is in the payload
        let lastActionObject = lastActions[action];

        let groupids = lastActionObject.groupids;

        const formidToAddGroup = lastActionObject.formid;

        let newNodeFormType = qf.formstate[formidToAddGroup].type;

        qf = FormProperties({ formtype: newNodeFormType }).removeGroups({
          groupids,
          node: {
            ...node,
            formid: formidToAddGroup,
            formtype: newNodeFormType,
          },
          qf: { ...qf },
        });
      }
      //#endregion

      //#region  undoing ADDFORMS
      if (action === ADDFORMS) {
        // as removing form will be same for any form type it will be common function

        // remove groups which is in the payload

        let formids = lastActions[action];
        // form cannot remove itself
        formids = _.difference(formids, [formid]);
        qf = removeForms({ qf: { ...qf }, formids, demandedActions });
      }
      //#endregion
    }

    // remove the lastActions from the node
    if (qf.formstate[formid] && qf.formstate[formid].nodestate[id])
      delete qf.formstate[formid].nodestate[id].lastActions;
  }

  return qf;
};

export const doDemandedActions = ({
  qf,
  node,
  demandedActions,
  isBuilding,
}) => {
  const { formid, formtype, id, locationid, buildingid } = node;
  const { questiontable, doc, formsorder } = qf;

  const { groupstable, formstable, answers } = doc;

  let refinedDemandedActions = {};
  if (demandedActions) {
    for (let action in demandedActions) {
      //#region  ADDQUESTIONS
      if (action === ADDQUESTIONS) {
        // add question in questionroder
        let questionids = demandedActions[action]; // getting payload of the action

        // refine the payload as per the question available in the table
        let { availableQuestionIds, questionTableInObjectForm } =
          getAvailableQuestionIdsAndQuestionTableInObjectForm({
            questionids,
            questiontable: qf.questiontable,
          });

        let nodeids = convertQuestionIdsToNodeIdsAsPerForm({
          questionids: availableQuestionIds,
          formtype,
          locationid,
          buildingid: buildingid,
        });

        qf.formstate[formid] = FormProperties({ formtype }).addQuestions({
          questionids: availableQuestionIds,
          nodeids,
          formstate: { ...qf.formstate[formid] },
          node,
          questionTableInObjectForm,
          questiontable: qf.questiontable,
          operations: getOperationListProspectDoc(doc),
        });

        // change the payload in the demanded actions as only the valid questionids should be there

        refinedDemandedActions[action] = availableQuestionIds;
      }
      //#endregion

      //#region  ADDQUESTIONSTOOTHERGROUP
      if (action === ADDQUESTIONSTOOTHERGROUP) {
        // add question in questionroder
        const actionObject = demandedActions[action]; // getting payload off the action

        let qfAndActionObject = addQuestionsToOtherGroupFunc({
          actionObject,
          formid,
          node,
          questiontable: qf.questiontable,
          locationid,
          qf: { ...qf },
          doc,
          getAvailableQuestionIdsAndQuestionTableInObjectForm,
          convertQuestionIdsToNodeIdsAsPerForm,
          FormProperties,
          getOperationListProspectDoc,
          buildingid,
        });

        qf = qfAndActionObject.qf;

        refinedDemandedActions[action] = qfAndActionObject.newActionObject;
      }
      //#endregion

      //#region  ADDQUESTIONSTOMULTIPLEGROUPS
      if (action === ADDQUESTIONSTOMULTIPLEGROUPS) {
        // add question in questionroder
        const actionObjects = demandedActions[action]; // getting payload off the action <-- Array of Objects

        refinedDemandedActions[action] = [];
        if (!_.isEmpty(actionObjects) && Array.isArray(actionObjects)) {
          for (let i = 0; i < actionObjects.length; i++) {
            let actionObject = actionObjects[i];
            let qfAndActionObject = addQuestionsToOtherGroupFunc({
              actionObject,
              formid,
              node,
              questiontable: qf.questiontable,
              locationid,
              qf: { ...qf },
              doc,
              getAvailableQuestionIdsAndQuestionTableInObjectForm,
              convertQuestionIdsToNodeIdsAsPerForm,
              FormProperties,
              getOperationListProspectDoc,
              buildingid,
            });

            qf = qfAndActionObject.qf;
            refinedDemandedActions[action] = [
              ...refinedDemandedActions[action],
              qfAndActionObject.newActionObject,
            ];
          }
        }
      }
      //#endregion

      //#region ADDGROUPS
      if (action === ADDGROUPS) {
        // find out all the questions under that group
        // clean the payload as it may contain some group ids which are not in the grouptable
        let groupids = demandedActions[action]; // getting payload of the action
        let addBuilding = false; // Initialize the variable

        // Remove 'e_99999_99a' from the array if it exists
        // groupids = _.pull(groupids, "e_99999_99a");

        let { availableGroupIds, groupTableInObjectForm } =
          getAvailableGroupIdsAndGroupTableInObjectForm({
            groupids,
            groupstable,
          });

        qf.formstate[formid] = FormProperties({ formtype }).addGroups({
          groupids: availableGroupIds,
          formstate: {
            ...qf.formstate[formid],
          },
          node,
          groupTableInObjectForm,
          questiontable: qf.questiontable,
          calculatedverticalid: qf.doc?.answers?.calculatedverticalid
        });

        if (_.includes(groupids, "e_100_50")) {
          addBuilding = true;
          //
          //
        }
        //change the payload in demanded actions as only valid groupids should be there
        refinedDemandedActions[action] = availableGroupIds;
      }
      //#endregion

      //#region ADDGROUPSTOOTHERFORM
      if (action === ADDGROUPSTOOTHERFORM) {
        // find out all the questions under that group
        // clean the payload as it may contain some group ids which are not in the grouptable
        const actionObject = demandedActions[action]; // getting payload of the action

        let groupids = actionObject.groupids;

        const formidToAddGroup = actionObject.formid;

        if (!_.isEmpty(qf.formstate[formidToAddGroup])) {
          let newNodeFormType = qf.formstate[formidToAddGroup].type;

          let { availableGroupIds, groupTableInObjectForm } =
            getAvailableGroupIdsAndGroupTableInObjectForm({
              groupids,
              groupstable,
            });

          qf.formstate[formidToAddGroup] = FormProperties({
            formtype: newNodeFormType,
          }).addGroups({
            groupids: availableGroupIds,
            formstate: {
              ...qf.formstate[formidToAddGroup],
            },
            node: {
              ...node,
              formid: formidToAddGroup,
              formtype: newNodeFormType,
            },
            groupTableInObjectForm,
            questiontable: qf.questiontable,
          });

          //change the payload in demanded actions as only valid groupids should be there
          refinedDemandedActions[action] = {
            ...actionObject,
            groupids: availableGroupIds,
          };
        } else {
          refinedDemandedActions[action] = {};
        }
      }
      //#endregion

      //#region ADDFORMS
      if (action === ADDFORMS) {
        // find out all the questions under that group
        // clean the payload as it may contain some group ids which are not in the grouptable
        let formids = demandedActions[action]; // getting payload of the action

        //#region Check which formids are already present in the formstate
        // This region will meant to Avoid removing the forms which are already present in formstate
        let formIdsAlreadyPresentinFormstate = [];
        let currentFormstate = qf.formstate;
        formids.forEach((formid) => {
          if (formid in currentFormstate) {
            formIdsAlreadyPresentinFormstate.push(formid);
          }
        });

        //#endregion

        let { availableFormIds, formTableInObjectForm } =
          getAvailableFormIdsAndFormTableInObjectForm({
            formids,
            formstable,
          });

        // already added form should not be added again
        formids = _.difference(
          availableFormIds,
          formIdsAlreadyPresentinFormstate
        );

        if (!_.isEmpty(formids)) {
          let formsOrderAndFormState = FormProperties({ formtype }).addForms({
            formids: availableFormIds,
            formstate: { ...qf.formstate },
            node,
            formTableInObjectForm,
            questiontable: qf.questiontable,
            groupstable,
            formsorder: [...formsorder],
            calculatedverticalid: answers.calculatedverticalid,
            operations: answers.operations.list,
          });

          qf.formstate = formsOrderAndFormState.formstate;
          qf.formsorder = formsOrderAndFormState.formsorder;
        }

        //change the payload in demanded actions as only valid formids should be there
        refinedDemandedActions[action] = availableFormIds;
      }
      //#endregion
    }

    // finally add the demandedActions to lastActions in node

    qf.formstate[formid].nodestate[id].lastActions = refinedDemandedActions;
  }

  return qf;
};

const figureOutCurrentNode = ({ formstate }) => {
  let firstNodeId = formstate?.nodesorder[0];

  if (firstNodeId) return formstate.nodestate[firstNodeId];

  return {};
};

export const initialBoostFormstateIfNull = ({ qf }) => {
  let groupstable = { ...qf.doc.groupstable };
  let questiontable = [...qf.questiontable];
  let doc = { ...qf.doc };
  qf.showFirstAutoAddedBuilding = false;
  qf.doc.formsorder.forEach((formid) => {
    let formtype = qf.doc.formstate[formid].type;
    if (qf.doc.formstate[formid].frontend_responsible ) {
      //
      qf.doc.formstate[formid] = FormProperties({
        formtype,
      }).createFormStateForFirstTime({
        currentformstate: { ...qf.doc.formstate[formid] },
        groupstable,
        questiontable,
        calculatedverticalid: getCalculateVerticalIdFromProspectDoc(doc),
        operations: getOperationListProspectDoc(doc),
        formid,
        prevappanswers: qf.doc?.otherdetails?.previousprospectanswers,
        triagedata: qf.doc?.otherdetails?.triagedata
      });

      //finally update the current node

      qf.doc.formstate[formid].currentnode = figureOutCurrentNode({
        formstate: qf.doc.formstate[formid],
      });

      delete qf.doc.formstate[formid].frontend_responsible;
    }
    //#region Check if the nodesorder are as per the groupstate questionorder
    // This region is particularly for operations form, as some forms
    // in the operation while adding the questions, it sorts the nodes order.
    // all NEW nodes order are in good shape, except old prospects which are in
    // DB before this edit.
    // To remove this region Here is what needs to be done in DB for every prospect:
    // For each prospect, check the below condition and if it is false, make the
    // nodes order in good shape. For now, keeping this task in TODO using for await
    // in backend.

    // TODO: edit DB for old prospects
    try {
      if (
        !(
          qf.doc.formstate[formid].nodesorder[0] ===
          FormProperties({ formtype }).getFirstNodeIdFromTree({
            formstate: qf.doc.formstate[formid],
          })
        )
      ) {
        qf.doc.formstate[formid] = FormProperties({
          formtype,
        }).updateNodesOrder({ formstate: { ...qf.doc.formstate[formid] } });
      }
    } catch (e) {}
    //#endregion
  });
  return qf;
};

export const isOnlyOneLocationAvaliable = ({ formid, formstate }) => {
  let bool = true;
  try {
    if (formstate[formid].locationsorder.length > 1) {
      bool = false;
    }
  } catch (e) {
    console.table({ error: "Error at isOnlyOneLocationAvaliable" });
  }

  return bool;
};

const getAllNodeIdsForLocationId = ({ locationid, formid, qf }) => {
  let returnValue = [];

  try {
    let locationFormNodesOrders = [...qf.formstate[formid].nodesorder];

    let locationNodesStartsWith = `location_${locationid}`;

    returnValue = locationFormNodesOrders.filter((nodeid) =>
      nodeid.includes(locationNodesStartsWith)
    );
  } catch (e) {
    console.table({ error: "ERROR AT getAllNodesForLocationId" });
  }

  return returnValue;
};

// lenroy look here for fix for building add
export const addBuilding = ({ qf, formid, locationid, buildingIndex }) => {
  let groupstable = { ...qf.doc.groupstable };
  let questiontable = [...qf.questiontable];
  let allFormsState = { ...qf.formstate };
  let doc = { ...qf.doc };

  const buidlingsLength =
    allFormsState[formid].locationstate[locationid].buildings.length;

  allFormsState[formid].locationstate[locationid].buildings[buildingIndex] = {
    groupsorder: ["e_100_50"],
    groupstate: {},
  };

  // allFormsState[formid].locationstate[locationid].buildings[buidlingsLength] =
  //   allFormsState[formid].locationstate[locationid].buildings[
  //     buidlingsLength - 1
  //   ];

  // Migration: If current location doesn't have buildingIntialState but location 1 does, copy it
  if (
    locationid !== 1 &&
    !allFormsState[formid].locationstate[locationid]?.buildingIntialState &&
    allFormsState[formid].locationstate[1]?.buildingIntialState
  ) {
    allFormsState[formid].locationstate[locationid].buildingIntialState =
      _.cloneDeep(allFormsState[formid].locationstate[1].buildingIntialState);
    allFormsState[formid].locationstate[locationid].buildingFirstQuestion =
      _.cloneDeep(allFormsState[formid].locationstate[1].buildingFirstQuestion);
  }

  allFormsState[formid] = updateBuildingAsPerBuildingsOrder({
    formstate: { ...allFormsState[formid] },
    groupstable,
    formid,
    calculatedverticalid: getCalculateVerticalIdFromProspectDoc(doc),
    operations: getOperationListProspectDoc(doc),
    questiontable,
    FormProperties,
    buildingIndex,
    locationid,
    buildingIntialState:
      allFormsState[formid].locationstate[locationid]["buildingIntialState"], // Use current location's building state
  });

  let newQf = { ...qf };

  newQf.formstate = allFormsState;

  return newQf;
};

export const addLocation = ({ qf, formid }) => {
  let groupstable = { ...qf.doc.groupstable };
  let questiontable = [...qf.questiontable];
  let allFormsState = { ...qf.formstate };
  let doc = { ...qf.doc };

  // update the locations order first
  allFormsState[formid].locationsorder = addSequenceElementToArray([
    ...allFormsState[formid].locationsorder,
  ]);

  allFormsState[formid] = updateLocationStateAsPerLocationsOrder({
    formstate: { ...allFormsState[formid] },
    groupstable,
    formid,
    calculatedverticalid: getCalculateVerticalIdFromProspectDoc(doc),
    operations: getOperationListProspectDoc(doc),
    questiontable,
    FormProperties,
  });

  let newQf = { ...qf };

  newQf.formstate = allFormsState;

  return newQf;
};

export const removeLocation = ({ formid, locationid, qf }) => {
  let qfFresh = { ...qf };
  try {
    // 1. Get all building indices in the location
    const buildingIndices = qf.formstate[formid].locationstate[
      locationid
    ].buildings.map((b, index) => index);

    // 2. Remove data from sessionStorage for each building in the location
    buildingIndices.forEach((buildingIndex) => {
      const sessionStorageKeyPrefix = `location_${locationid}_building_${buildingIndex}`;

      Object.keys(sessionStorage).forEach((key) => {
        if (key.startsWith(sessionStorageKeyPrefix)) {
          sessionStorage.removeItem(key);
        }
      });
    });
    // get all the nodeids to remove in an array
    let allLocationNodeIds = getAllNodeIdsForLocationId({
      formid,
      locationid,
      qf: qfFresh,
    });
    // call removenodesandundolastaction
    qfFresh = removeNodesAndUndoLastAction({
      formid,
      qf: qfFresh,
      nodeids: allLocationNodeIds,
      undoLastActionsRescursively,
    });
    // update locationorder and locationstate by removing locationid and its properties
    qfFresh.formstate[formid].locationsorder = _.difference(
      [...qfFresh.formstate[formid].locationsorder],
      [locationid]
    );
    delete qfFresh.formstate[formid].locationstate[locationid];

    // change the currentnode to first node of the this form
    let firstNodeOfThisForm =
      qfFresh.formstate[formid].nodestate[
        qfFresh.formstate[formid].nodesorder[0]
      ];
    qfFresh.formstate[formid].currentnode = { ...firstNodeOfThisForm };
    qfFresh.formstate.currentnode = { ...firstNodeOfThisForm };
  } catch (e) {
    console.table({ error: "ERROR AT removeLocation" });
  }

  return qfFresh;
};

export function removeBuilding({
  data,
  locationid,
  formid,
  buildingIndexToDelete,
}) {
  let tempState = _.cloneDeep(data);

  // 1. Delete the building
  if (
    tempState.formstate[formid].locationstate[locationid].buildings.length > 1
  ) {
    tempState.formstate[formid].locationstate[locationid].buildings.splice(
      buildingIndexToDelete,
      1
    );
  } else {
    tempState.formstate[formid].locationstate[locationid].buildings = [
      {
        groupsorder: [],
        groupstate: {},
      },
    ];
  }
  const buildingIndices = tempState.formstate[formid].nodesorder.map((node) => {
    const match = node.match(/location_\d+_building_(\d+)_/);
    return match ? parseInt(match[1], 10) : -1;
  });

  // Helper function to generate the prefix
  const generatePrefix = (locId, buildingId) =>
    `location_${locId}_building_${buildingId}`;

  // 2. Remove all nodes related to the deleted building in nodesorder and nodestate
  const buildingPrefixToDelete = generatePrefix(
    locationid,
    buildingIndexToDelete
  );

  tempState.formstate[formid].nodesorder = tempState.formstate[
    formid
  ].nodesorder.filter((node) => !node.startsWith(buildingPrefixToDelete));

  //Loop through the array and check each key
  for (const nodeId in tempState.formstate[formid].nodestate) {
    if (nodeId.startsWith(buildingPrefixToDelete)) {
      delete tempState.formstate[formid].nodestate[nodeId];
    }
  }

  // 3. Adjust all subsequent building references in nodesorder and nodestate
  const subsequentBuildingIndices = tempState.formstate[formid].nodesorder
    .map((node) => {
      const match = node.match(/location_\d+_building_(\d+)_/);
      return match ? parseInt(match[1], 10) : -1;
    })
    .filter((index) => index > buildingIndexToDelete);

  for (const index of subsequentBuildingIndices) {
    const oldPrefix = generatePrefix(locationid, index);
    const newPrefix = generatePrefix(locationid, index - 1);

    // Adjust nodesorder
    tempState.formstate[formid].nodesorder = tempState.formstate[
      formid
    ].nodesorder.map((node) =>
      node.startsWith(oldPrefix) ? node.replace(oldPrefix, newPrefix) : node
    );

    // Adjust nodestate
    for (const nodeId in tempState.formstate[formid].nodestate) {
      if (nodeId.startsWith(oldPrefix)) {
        const newNodeId = nodeId.replace(oldPrefix, newPrefix);
        tempState.formstate[formid].nodestate[newNodeId] = {
          ...tempState.formstate[formid].nodestate[nodeId],
          id: newNodeId,
          buildingid: index - 1,
        };
        delete tempState.formstate[formid].nodestate[nodeId];
      }
    }
  }

  // 4. Remove data from session storage for the deleted building
  const sessionStorageKeyToDelete = generatePrefix(
    locationid,
    buildingIndexToDelete
  );

  //
  // sessionStorage.removeItem(sessionStorageKeyToDelete);

  data.formstate[formid].nodesorder.forEach((key) => {
    if (key.startsWith(sessionStorageKeyToDelete)) {
      sessionStorage.removeItem(key);
    }
  });

  // 5. Adjust session storage keys for subsequent buildings
  // 5. Identify unique subsequent building indices and sort them
  let uniqueSubsequentIndices = Array.from(
    new Set(
      data.formstate[formid].nodesorder
        .map((node) => {
          const match = node.match(/location_\d+_building_(\d+)_/);
          return match ? parseInt(match[1], 10) : -1;
        })
        .filter((index) => index > buildingIndexToDelete)
    )
  ).sort((a, b) => a - b);

  // Update session storage keys for subsequent buildings
  uniqueSubsequentIndices.forEach((index) => {
    const oldSessionKeyPrefix = generatePrefix(locationid, index);
    const newSessionKeyPrefix = generatePrefix(locationid, index - 1);

    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith(oldSessionKeyPrefix)) {
        const newKey = key.replace(oldSessionKeyPrefix, newSessionKeyPrefix);
        const dataInSession = sessionStorage.getItem(key);
        if (dataInSession) {
          sessionStorage.setItem(newKey, dataInSession);
          sessionStorage.removeItem(key);
        }
      }
    });
  });

  return tempState;
}

const findMainOperationForm = ({ formstate, formsorder }) => {
  let operationformid = null;
  formsorder.forEach((formid) => {
    if (formstate[formid].type === OPERATION) operationformid = formid;
  });

  return operationformid;
};

const generateFormIdForNewOperationForm = ({ operationformid }) => {
  return `${operationformid}_a`;
};

const determineGroupsInGroupsOut = ({
  operationids,
  groupsorder,
  groupstate,
}) => {
  let groupsIn = [];
  let groupsOut = [];

  groupsorder.forEach((groupid) => {
    if (intersection(groupstate[groupid].operationids, operationids))
      groupsIn.push(groupid);
    else groupsOut.push(groupid);
  });

  return { groupsIn, groupsOut };
};

export const addExtraOperation_Form = ({ qf }) => {
  const { formstate, formsorder, doc, questiontable } = qf;
  const { groupstable } = doc;

  //STEP 1 : FIND THE MAIN OPERTION FORM
  let operationformid = findMainOperationForm({ formstate, formsorder });

  if (operationformid === null)
    return { formstate: qf.formstate, formsorder: qf.formsorder };

  // RUN THIS WHOLE FUNCTION ONLY IF NEVER RAN BEFORE FOR THIS PROSPECT
  if (!formstate[operationformid].add_extra_form)
    return { formstate: qf.formstate, formsorder: qf.formsorder };

  // STEP 2: COPY IT AND CHANGE ID, TEXT, TYPE, ALLINONEPAGE,  NECESSARY VALUES IN IT EXCEPT GROUPSORDER AND GROUPSTATE

  let { groupsIn, groupsOut } = determineGroupsInGroupsOut({
    operationids: getOperationListProspectDoc(doc).map((op) => op.id),
    groupsorder: formstate[operationformid].groupsorder,
    groupstate: formstate[operationformid].groupstate,
  });

  // First remove the groups from the original operations form
  qf = FormProperties({ formtype: OPERATION }).removeGroups({
    groupids: groupsIn,
    node: { formid: operationformid },
    qf: { ...qf },
  });

  // STEP 3: CREATE A NEW MASTERGROUP FORM
  let newOperationFormId = generateFormIdForNewOperationForm({
    operationformid,
  });
  // formstate
  let newMGFormState = {
    id: newOperationFormId,
    type: MASTERGROUP,
    text: {
      en: OTHER_OPERATION_TEXT_EN,
      fr: OTHER_OPERATION_TEXT_FR,
    },
    description: {
      en: "",
      fr: "",
    },
    allinonepage: true,
    nodesorder: [],
    nodestate: {},
    groupsorder: [],
    groupstate: {},
  };
  qf.formstate[newOperationFormId] = { ...newMGFormState };

  // formsorder
  qf.formsorder = [...formsorder, newOperationFormId].sort();

  // finally add Group in the mastergroup form:

  let { availableGroupIds, groupTableInObjectForm } =
    getAvailableGroupIdsAndGroupTableInObjectForm({
      groupids: [...groupsIn, LAST_GROUPID_OF_EXTRA_OPERATION_FORM],
      groupstable,
    });
  qf.formstate[newOperationFormId] = FormProperties({
    formtype: MASTERGROUP,
  }).addGroups({
    groupids: availableGroupIds,
    formstate: {
      ...qf.formstate[newOperationFormId],
    },
    node: {
      formid: newOperationFormId,
      formtype: MASTERGROUP,
    },
    groupTableInObjectForm,
    questiontable,
  });

  qf.formstate[newOperationFormId].currentnode =
    qf.formstate[newOperationFormId].nodestate[
      qf.formstate[newOperationFormId].nodesorder[0]
    ];

  // do the add_extra_form to false
  qf.formstate[operationformid].add_extra_form = false;

  return { formstate: qf.formstate, formsorder: qf.formsorder };
};

//#endregion

//#region Form Properties

const convertQuestionIdsToNodeIdsAsPerForm = ({
  questionids,
  locationid,
  formtype,
  buildingid,
}) => {
  let nodeids = [];
  questionids.forEach((questionid) => {
    if (buildingid === "" || buildingid === undefined) {
      nodeids.push(
        FormProperties({ formtype }).getNodeId({ questionid, locationid })
      );
    } else {
      nodeids.push(
        "location_" + locationid + "_building_" + buildingid + "_" + questionid
        // FormProperties({ formtype }).getNodeId({ questionid, locationid })
      );
    }
  });
  return nodeids;
};

const removeQuestionsFromMGGroup = ({ questionids, qf, node, nodeids }) => {
  const { groupid, formid } = node;

  if (
    qf &&
    qf.formstate &&
    qf.formstate[formid] &&
    qf.formstate[formid].groupstate &&
    qf.formstate[formid].groupstate[groupid]
  ) {
    const { questionsorder, dynamic, index } =
      qf.formstate[formid].groupstate[groupid];

    if (dynamic) {
      // This means that the question is from Dynamic group like  0_operation_1
      // For this you need to change the questionids and the nodeids as per operation
      questionids = questionids.map((questionid) =>
        createOperationNodeId({ index, questionid })
      );
      nodeids = questionids;
    }

    qf.formstate[formid].groupstate[groupid].questionsorder = _.difference(
      questionsorder,
      questionids
    );

    // delete all the nodestate[nodeid] ===> VERY IMP: BEFORE DELETING, MAKE SURE THEIR LAST ACTIONS UNDO  <==

    qf = removeNodesAndUndoLastAction({
      qf,
      formid,
      nodeids,
      undoLastActionsRescursively,
    });
  }

  return qf;
};

const removeQuestionsFromLocationGroup = ({
  questionids,
  qf,
  node,
  nodeids,
}) => {
  const { groupid, formid, locationid, buildingid } = node;
  let questionsorder = [];
  //

  // const { questionsorder } =
  //   qf.formstate[formid]?.locationstate[locationid].groupstate[groupid];

  if (
    qf &&
    qf.formstate &&
    qf.formstate[formid] &&
    qf.formstate[formid].locationstate &&
    qf.formstate[formid].locationstate[locationid] &&
    qf.formstate[formid].locationstate[locationid].groupstate &&
    qf.formstate[formid].locationstate[locationid].groupstate[groupid] &&
    (buildingid === "" || buildingid === undefined)
  ) {
    // console.log(
    //   "on top of the world",
    //   JSON.parse(
    //     JSON.stringify(
    //       qf.formstate[formid].locationstate[locationid].groupstate[groupid]
    //         .questionsorder
    //     )
    //   )
    // );
    // console.log(
    //   "on top of the world part 1",
    //   JSON.parse(JSON.stringify(groupid))
    // );
    questionsorder =
      qf.formstate[formid]?.locationstate[locationid].groupstate[groupid]
        .questionsorder;

    qf.formstate[formid].locationstate[locationid].groupstate[
      groupid
    ].questionsorder = _.difference(questionsorder, questionids);
  }

  if (
    qf &&
    qf.formstate &&
    qf.formstate[formid] &&
    qf.formstate[formid].locationstate &&
    qf.formstate[formid].locationstate[locationid] &&
    qf.formstate[formid].locationstate[locationid].buildings &&
    qf.formstate[formid].locationstate[locationid].buildings[buildingid] &&
    qf.formstate[formid].locationstate[locationid].buildings[buildingid]
      .groupstate[groupid]
  ) {
    questionsorder =
      qf.formstate[formid]?.locationstate[locationid].buildings[buildingid]
        .groupstate[groupid].questionsorder;

    qf.formstate[formid].locationstate[locationid].buildings[
      buildingid
    ].groupstate[groupid].questionsorder = _.difference(
      questionsorder,
      questionids
    );
  }

  // delete all the nodestate[nodeid] ===> VERY IMP: BEFORE DELETING, MAKE SURE THEIR LAST ACTIONS UNDO  <==
  //
  //
  //

  qf = removeNodesAndUndoLastAction({
    qf,
    formid,
    nodeids,
    undoLastActionsRescursively,
  });

  return qf;
};

const addQuestionsToMGGroup = ({
  questionids,
  formstate,
  node,
  nodeids,
  questionTableInObjectForm,
}) => {
  const { formid, formtype, groupid } = node;

  if (formstate && formstate.groupstate && formstate.groupstate[groupid]) {
    let { questionsorder } = formstate.groupstate[groupid];
    formstate.groupstate[groupid].questionsorder = [
      ...new Set([...questionsorder, ...questionids].sort()),
    ];

    formstate = FormProperties({ formtype }).updateNodesOrder({ formstate });

    formstate = FormProperties({ formtype }).updateNodeStateUsingNodesOrder({
      formstate,
      formid,
      formtype,
      groupid,
      questionTableInObjectForm,
    });
  }

  return formstate;
};

const addQuestionsToOperationForm = ({
  questionids,
  formstate,
  node,
  nodeids,
  questionTableInObjectForm,
  questiontable,
  operations,
}) => {
  const { groupid } = node;

  if (formstate && formstate.groupstate && formstate.groupstate[groupid]) {
    const { dynamic, index } = formstate.groupstate[groupid];

    if (dynamic) {
      let newQuestionTableInObjectForm = {};
      let newQuestionIds = [];
      questionids.forEach((questionid) => {
        let operationQuestionId = createOperationNodeId({ index, questionid });
        newQuestionIds.push(operationQuestionId);
        newQuestionTableInObjectForm[operationQuestionId] = {
          ...questionTableInObjectForm[questionid],
          id: operationQuestionId,
          groupid: createOperationGroupId({ operationNumber: index }),
          questionid,
          index,
          operation: operations[index - 1],
        };
      });

      return addQuestionsToMGGroup({
        questionids: newQuestionIds,
        formstate,
        node,
        nodeids: newQuestionIds,
        questionTableInObjectForm: newQuestionTableInObjectForm,
      });
    } else {
      // if code comes here means that the node is not dynamic ( means it is not the operation group)
      return addQuestionsToMGGroup({
        questionids,
        formstate,
        node,
        nodeids,
        questionTableInObjectForm,
      });
    }
  } else {
    return formstate;
  }
};

const addQuestionsToLocationGroup = ({
  questionids,
  formstate,
  node,
  nodeids,
  questionTableInObjectForm,
}) => {
  const { formid, formtype, groupid, locationid, buildingid } = node;

  let tempBuildingid = buildingid;

  if (
    (tempBuildingid === "" || tempBuildingid === undefined) &&
    groupid === "e_100_50"
  ) {
    tempBuildingid = 0;
  }

  //look here for big fix to get 3 or more
  if (node.buildingid >= 0 && groupid === "e_100_50" && buildingid != "") {
    tempBuildingid = node.buildingid;
  }

  if (
    formstate.locationstate &&
    formstate.locationstate[locationid] &&
    formstate.locationstate[locationid].groupstate &&
    formstate.locationstate[locationid].groupstate[groupid] &&
    (buildingid === "" || buildingid === undefined) &&
    groupid != "e_100_50"
  ) {
    let { questionsorder } =
      formstate.locationstate[locationid].groupstate[groupid];

    formstate.locationstate[locationid].groupstate[groupid].questionsorder = [
      ...new Set([...questionsorder, ...questionids].sort()),
    ];

    formstate = FormProperties({ formtype }).updateNodesOrder({
      formstate,
    });

    formstate = FormProperties({ formtype }).updateNodeStateUsingNodesOrder({
      formstate,
      formid,
      formtype,
      groupid,
      questionTableInObjectForm,
    });
  }

  if (
    formstate.locationstate &&
    formstate.locationstate[locationid] &&
    formstate.locationstate[locationid].buildings &&
    formstate.locationstate[locationid].buildings[tempBuildingid] &&
    formstate.locationstate[locationid].buildings[tempBuildingid].groupstate[
      groupid
    ]
    //   ||
    // groupid === "e_99999_99a"
  ) {
    let { questionsorder } =
      formstate.locationstate[locationid].buildings[tempBuildingid].groupstate[
        groupid
      ];

    formstate.locationstate[locationid].buildings[tempBuildingid].groupstate[
      groupid
    ].questionsorder = [...new Set([...questionsorder, ...questionids].sort())];

    formstate = FormProperties({ formtype }).updateNodesOrder({
      formstate,
      tempBuildingid,
    });

    formstate = FormProperties({ formtype }).updateNodeStateUsingNodesOrder({
      formstate,
      formid,
      formtype,
      groupid,
      questionTableInObjectForm,
    });
  }

  return formstate;
};

const addMGForms = ({
  formstate,
  formids,
  node,
  formTableInObjectForm,
  groupstable,
  questiontable,
  formsorder,
  calculatedverticalid,
  operations,
}) => {
  // STEP 1 UPDATE FORMSORDER
  // STEP 2 ADD FORMSTATE FOR EVERY FORMID
  // STEP 3 UPDATE NODESORDER AND NODESTATE

  formsorder = [...new Set([...formsorder, ...formids])].sort();

  if (!_.isEmpty(formids)) {
    formids.forEach((formid) => {
      // forms own properties
      formstate[formid] = { ...formTableInObjectForm[formid] };

      formstate[formid].groupsorder = getFilteredGroupsUnderForm({
        formid,
        groupstable,
        calculatedverticalid,
        operations,
      })
        .map((group) => group.id)
        .sort();

      if (!formstate[formid].groupstate) formstate[formid].groupstate = {};

      let formstateAndQuestionTableInObject = updateGroupStateAsPerGroupsOrder({
        formstate: { ...formstate[formid] },
        groupTableInObjectForm: groupstable,
        formid,
        questiontable,
        calculatedverticalid,
        operations: operations || [],
      });

      formstate[formid] = formstateAndQuestionTableInObject.formstate;

      let questionInObjectForAllGroups =
        formstateAndQuestionTableInObject.questionInObjectForAllGroups;

      // update nodesorder as per the formstate, as it has groupstate and questions order in ti
      formstate[formid] = FormProperties({
        formtype: formstate[formid].type,
      }).updateNodesOrder({ formstate: { ...formstate[formid] } });

      if (!formstate[formid].nodestate) {
        formstate[formid].nodestate = {};
      }

      formstate[formid] = FormProperties({
        formtype: formstate[formid].type,
      }).updateNodeStateUsingNodesOrder({
        formstate: { ...formstate[formid] },
        formid,
        formtype: formstate[formid].type,
        questionTableInObjectForm: questionInObjectForAllGroups,
      });

      // finally add currentnode as first nodesorder from nodestate
      if (!_.isEmpty(formstate[formid].nodesorder)) {
        formstate[formid].currentnode =
          formstate[formid].nodestate[formstate[formid].nodesorder[0]];
      }
    });
  }

  return { formsorder, formstate };
};

const addGroupsToMGForm = ({
  groupids,
  formstate,
  node,
  groupTableInObjectForm,
  questiontable,
}) => {
  const { groupsorder } = formstate;
  const { formtype, formid } = node;

  // STEP 1 UPDATE GROUPSORDER AND GROUPSTATE
  // STEP 2 UPDATE NODESTATE AND NODESORDER
  formstate.groupsorder = [...new Set([...groupsorder, ...groupids].sort())];

  let formstateAndQuestionTableInObject = updateGroupStateAsPerGroupsOrder({
    formstate,
    groupTableInObjectForm,
    formid,
    questiontable,
  });

  formstate = formstateAndQuestionTableInObject.formstate;
  let questionInObjectForAllGroups =
    formstateAndQuestionTableInObject.questionInObjectForAllGroups;

  // update nodesorder and then nodestate
  formstate = FormProperties({ formtype }).updateNodesOrder({ formstate });

  formstate = FormProperties({ formtype }).updateNodeStateUsingNodesOrder({
    formstate,
    formid,
    formtype,
    questionTableInObjectForm: questionInObjectForAllGroups,
  });

  return formstate;
};

const addGroupsToLocationForm = ({
  groupids,
  formstate,
  node,
  groupTableInObjectForm,
  questiontable,
  calculatedverticalid
}) => {
  const { formtype, formid, locationid, buildingid } = node;

  let groupsorder = [];
  let tempBuildingid = buildingid;

  // STEP 1 UPDATE GROUPSORDER AND GROUPSTATE
  // STEP 2 UPDATE NODESTATE AND NODESORDER
  //check if its a building or location
  if (tempBuildingid === "" || tempBuildingid === undefined) {
    groupsorder = formstate.locationstate[locationid].groupsorder;
    formstate.locationstate[locationid].groupsorder = [
      ...new Set([...groupsorder, ...groupids].sort()),
    ];
  } else {
    groupsorder =
      formstate.locationstate[locationid].buildings[tempBuildingid].groupsorder;

    formstate.locationstate[locationid].buildings[tempBuildingid].groupsorder =
      [...new Set([...groupsorder, ...groupids].sort())];
  }

  // console.log(
  //   "groupTableInObjectForm formstate.locationstate[locationid].buildings ",
  //   formstate.locationstate[locationid].buildings.length
  // );

  // this is the intializer of the buildings when group e_100_50 is selected
  if (
    _.includes(groupids, "e_100_50") &&
    formstate.locationstate[locationid].buildings.length >= 0 &&
    formstate.locationstate[locationid].autoBuildingHasBeenAdded === undefined // This variable does not exist at the start, so we use it to see if we have already added the building information
  ) {
    groupsorder = formstate.locationstate[locationid].buildings[0].groupsorder;
    formstate.locationstate[locationid].buildings[0].groupsorder = [
      ...new Set([...groupsorder, "e_100_50"].sort()),
    ];
    // this is a flag for me to know if the building has been added already
    formstate.locationstate[locationid].autoBuildingHasBeenAdded = true;
    tempBuildingid = 0;
  }

  // then the state gets updated correctly
  let formstateAndQuestionTableInObject = updateGroupStateAsPerGroupsOrder({
    formstate: { ...formstate.locationstate[locationid] },
    groupTableInObjectForm,
    formid,
    questiontable,
    calculatedverticalid
  });

  formstate.locationstate[locationid] =
    formstateAndQuestionTableInObject.formstate;

  let questionInObjectForAllGroups =
    formstateAndQuestionTableInObject.questionInObjectForAllGroups;

  // update nodesorder and then nodestate
  formstate = FormProperties({ formtype }).updateNodesOrder({
    formstate,
    tempBuildingid,
  });

  formstate = FormProperties({ formtype }).updateNodeStateUsingNodesOrder({
    formstate,
    formid,
    formtype,
    questionTableInObjectForm: questionInObjectForAllGroups,
  });

  return formstate;
};

const updateMGNodesOrder = ({ formstate }) => {
  const { groupsorder } = formstate;

  let newNodesorder = [];
  groupsorder.forEach((groupid) => {
    newNodesorder = [
      ...newNodesorder,
      ...formstate.groupstate[groupid].questionsorder,
    ];
  });

  formstate.nodesorder = [...newNodesorder];

  return formstate;
};

const updateLocationNodesOrder = ({ formstate, buildingid = "" }) => {
  const { locationsorder, locationstate, type } = formstate;

  let newNodesorder = [];
  locationsorder.forEach((locationid) => {
    const { groupsorder, groupstate, buildings } = locationstate[locationid];

    groupsorder.forEach((groupid) => {
      newNodesorder = [
        ...newNodesorder,
        ...convertQuestionIdsToNodeIdsAsPerForm({
          questionids: groupstate[groupid].questionsorder,
          locationid,
          formtype: type,
          buildingid: "",
        }),
      ];
    });

    // update the node order with the buildings group order too

    //

    if (buildings && buildings.length > 0) {
      buildings.map((building, index) => {
        building.groupsorder.forEach((groupId) => {
          newNodesorder = [
            ...newNodesorder,
            ...building.groupstate[groupId].questionsorder.map((question) => {
              return (
                "location_" + locationid + "_building_" + index + "_" + question
              );
            }),
          ];
        });
      });
    }
  });

  //

  formstate.nodesorder = [...newNodesorder];

  return formstate;
};

function testJSON(text) {
  if (typeof text !== "string") return false;
  try {
    var json = JSON.parse(text);
    return typeof json === "object";
  } catch (error) {
    return false;
  }
}

const updateMGNodeStateUsingNodesOrder = ({
  formstate,
  formid,
  formtype,
  groupid,
  questionTableInObjectForm,
  prevappanswers
}) => {
  let time = new Date().getTime();
  formstate.nodesorder.forEach((nodeid) => {
    let isNodeStateAlreadyThere = formstate.nodestate[nodeid] ? true : false;
    if (!isNodeStateAlreadyThere) {
      let newNode = {
        formtype: formtype,
        questionid: nodeid,
        ...questionTableInObjectForm[nodeid],
        formid: formid,
        time:time,
      };

      // TODO: update for default answer
      if (newNode.logic && "defaultanswer" in newNode.logic) {
        newNode.answer = newNode.logic.defaultanswer;
      } else if (newNode.logic && newNode.logic.relatedanswers?.length > 0) {
        var notFound = true;
        for (var relatedAnswer of newNode.logic.relatedanswers) {
          if (notFound && formstate.nodestate[relatedAnswer]?.answer) {
            notFound = false;
            newNode.answer = formstate.nodestate[relatedAnswer].answer;
          }
        }
      }
      // imidatelly set answer upon creation
      if (sessionStorage.getItem(newNode.id)) {
        if (testJSON(sessionStorage.getItem(newNode.id)))
          newNode.answer = JSON.parse(sessionStorage.getItem(newNode.id));
        else newNode.answer = sessionStorage.getItem(newNode.id);
      }
      delete newNode._id;
      delete newNode.__v;
      //assign previous app answers if passthru, should only pass thru during creation of app no other times
      if(prevappanswers && prevappanswers[nodeid]){
        newNode.answer = prevappanswers[nodeid];
      }
      else if (newNode?.logic?.industrysibling){
        //console.log("prevappanswers ", prevappanswers);
        if(!prevappanswers){
          //console.log("prevappanswers is missing")
        }
        for(let industrysibling of newNode?.logic?.industrysibling){
          //console.log("industrysibling ", industrysibling);
          //console.log("prevappanswers[industrysibling] ", prevappanswers[industrysibling]);
          if(prevappanswers && prevappanswers[industrysibling] && newNode.answer == undefined){
            newNode.answer = prevappanswers[industrysibling];
          }
        }
      }

      // if the groupid is given in parameter then and then only update the group id else not
      if (!_.isEmpty(groupid) || !isNaN(groupid)) {
        newNode.groupid = groupid;
      }

      formstate.nodestate[nodeid] = newNode;
    }
  });

  return formstate;
};

const updateLocationNodeStateUsingNodesOrder = ({
  formstate,
  formid,
  formtype,
  groupid,
  questionTableInObjectForm,
}) => {
  //
  let timeCreated = new Date().getTime();
  formstate.nodesorder.forEach((nodeid) => {
    let isNodeStateAlreadyThere = formstate.nodestate[nodeid] ? true : false;

    if (!isNodeStateAlreadyThere) {
      let d_questionid = "";
      let d_locationid = "";
      let d_buildingid = "";

      if (nodeid.includes("building")) {
        let parts = nodeid.split("_building_");
        let locationPart = parts[0];
        let rest = parts[1];

        d_locationid = locationPart.split("_")[1];

        let restParts = rest.split("_");
        d_buildingid = Number(restParts[0]);
        d_questionid = restParts.slice(1).join("_"); // take the rest of the parts and join them
      } else {
        let locationIdAndQuestionId = FormProperties({
          formtype,
        }).demistifyNodeId({ nodeid }); // i can make a custom building nodeID
        d_questionid = locationIdAndQuestionId.questionid;
        d_locationid = locationIdAndQuestionId.locationid;
      }

      let tempTable = _.cloneDeep(questionTableInObjectForm);

      if (d_buildingid >= 0) {
        // copy over questions
        let tempNodeState = _.cloneDeep(
          formstate.nodestate[
            `location_${d_locationid}_building_0_${d_questionid}`
          ]
        );
        // we can utlize the fact that the very first question will always have the question we can directly copy
        if (tempNodeState) {
          delete tempNodeState.answer;
          tempTable[d_questionid] = tempNodeState;
        }
      }

      let newNode = {
        formtype: formtype,
        questionid: d_questionid,
        locationid: d_locationid,
        ...tempTable[d_questionid],
        formid: formid,
        time: timeCreated,
        id: nodeid,
        buildingid: d_buildingid,
      };

      if (sessionStorage.getItem(newNode.id)) {
        if (testJSON(sessionStorage.getItem(newNode.id)))
          newNode.answer = JSON.parse(sessionStorage.getItem(newNode.id));
        else newNode.answer = sessionStorage.getItem(newNode.id);
      }
      delete newNode._id;
      delete newNode.__v;

      // if the groupid is given then and then only update the group id else not
      if (!_.isEmpty(groupid) || !isNaN(groupid)) {
        newNode.groupid = groupid;
      }

      formstate.nodestate[nodeid] = newNode;
    }
  });

  // console.log(
  //   "the new formstate should be good",
  //   JSON.parse(JSON.stringify(formstate))
  // );

  return formstate;
};

const removeGroupsFromMGGroup = ({ qf, groupids, node }) => {
  const { formid } = node;

  let nodeidstoremove = [];
  if (!_.isEmpty(groupids)) {
    groupids.forEach((groupid) => {
      if (
        !_.isEmpty(qf.formstate[formid].groupstate[groupid]?.questionsorder)
      ) {
        nodeidstoremove = [
          ...nodeidstoremove,
          ...qf.formstate[formid].groupstate[groupid].questionsorder,
        ];
      }
    });

    qf.formstate[formid].groupsorder = _.difference(
      qf.formstate[formid].groupsorder,
      groupids
    );

    let newGroupState = {};
    qf.formstate[formid].groupsorder.forEach((groupid) => {
      newGroupState[groupid] = qf.formstate[formid].groupstate[groupid];
    });

    qf.formstate[formid].groupstate = newGroupState;

    qf = removeNodesAndUndoLastAction({
      formid,
      qf,
      nodeids: nodeidstoremove,
      undoLastActionsRescursively,
    });
  }

  return qf;
};

const removeGroupsFromLocationGroup = ({ qf, groupids, node }) => {
  const { formid, locationid, formtype, buildingid } = node;

  let nodeidstoremove = [];
  //removes groups for location
  if (
    !_.isEmpty(groupids) &&
    _.isEmpty(buildingid) &&
    (buildingid === "" || buildingid === undefined)
  ) {
    groupids.forEach((groupid) => {
      if (
        !_.isEmpty(
          qf.formstate[formid].locationstate[locationid].groupstate[groupid]
            ?.questionsorder
        )
      ) {
        nodeidstoremove = [
          ...nodeidstoremove,
          ...convertQuestionIdsToNodeIdsAsPerForm({
            questionids:
              qf.formstate[formid].locationstate[locationid].groupstate[groupid]
                .questionsorder,
            locationid,
            formtype,
            buildingid,
          }),
        ];
      }
    });

    qf.formstate[formid].locationstate[locationid].groupsorder = _.difference(
      qf.formstate[formid].locationstate[locationid].groupsorder,
      groupids
    );

    let newGroupState = {};
    qf.formstate[formid].locationstate[locationid].groupsorder.forEach(
      (groupid) => {
        newGroupState[groupid] =
          qf.formstate[formid].locationstate[locationid].groupstate[groupid];
      }
    );

    qf.formstate[formid].locationstate[locationid].groupstate = newGroupState;

    qf = removeNodesAndUndoLastAction({
      formid,
      qf,
      nodeids: nodeidstoremove,
      undoLastActionsRescursively,
    });
  }

  if (!_.isEmpty(groupids) && buildingid >= 0 && buildingid !== "") {
    groupids.forEach((groupid) => {
      if (
        !_.isEmpty(
          qf.formstate[formid].locationstate[locationid].buildings[buildingid]
            .groupstate[groupid]?.questionsorder
        )
      ) {
        nodeidstoremove = [
          ...nodeidstoremove,
          ...convertQuestionIdsToNodeIdsAsPerForm({
            questionids:
              qf.formstate[formid].locationstate[locationid].buildings[
                buildingid
              ].groupstate[groupid].questionsorder,
            locationid,
            formtype,
            buildingid,
          }),
        ];
      }
    });

    qf.formstate[formid].locationstate[locationid].buildings[
      buildingid
    ].groupsorder = _.difference(
      qf.formstate[formid].locationstate[locationid].buildings[buildingid]
        .groupsorder,
      groupids
    );

    let newGroupState = {};
    qf.formstate[formid].locationstate[locationid].buildings[
      buildingid
    ].groupsorder.forEach((groupid) => {
      newGroupState[groupid] =
        qf.formstate[formid].locationstate[locationid].buildings[
          buildingid
        ].groupstate[groupid];
    });

    qf.formstate[formid].locationstate[locationid].buildings[
      buildingid
    ].groupstate = newGroupState;

    qf = removeNodesAndUndoLastAction({
      formid,
      qf,
      nodeids: nodeidstoremove,
      undoLastActionsRescursively,
    });
  }

  return qf;
};

const getAddFormsArrayFromNodeStatesLastActions = ({ qf }) => {
  let returnValue = [];

  try {
    qf.formsorder.forEach((formid) => {
      let nodestate = qf.formstate[formid].nodestate;
      for (let nodeid in nodestate) {
        let node = qf.formstate[formid].nodestate[nodeid];
        if ("lastActions" in node) {
          if (ADDFORMS in node.lastActions) {
            returnValue = [...returnValue, ...node.lastActions[ADDFORMS]];
          }
        }
      }
    });
  } catch (e) {
    console.table({
      error: "Error in getAddFormsArrayFromNodeStatesLastActions",
    });
  }

  return returnValue;
};

const isDemandedActionContainsThisFormIdinADDFORMS = ({
  demandedActions,
  formid,
}) => {
  let returnBool = false;

  try {
    if (ADDFORMS in demandedActions) {
      returnBool = demandedActions[ADDFORMS].includes(formid);
    }
  } catch (e) {}

  return returnBool;
};

const shouldFormBeRemoved = ({ qf, formid, demandedActions }) => {
  // this functions implements form-remove-policy
  // form-remove-policy: If the form is already added by multiple questions,
  //                     form should not be removed
  //                     How to implement form-remove-policy?
  //                        Gather every formstate lastActions' addForms array
  //                        If that array contains this formid more than once
  //                        then abort its deletion.
  let returnBool = false;
  let everyAddFormsArrayFromNodeStatesLastActions =
    getAddFormsArrayFromNodeStatesLastActions({ qf });

  let filteredArray = everyAddFormsArrayFromNodeStatesLastActions.filter(
    (frmid) => frmid === formid
  );

  try {
    if (
      filteredArray.length === 1 &&
      !isDemandedActionContainsThisFormIdinADDFORMS({
        demandedActions,
        formid,
      })
    ) {
      returnBool = true;
    }
  } catch (e) {
    console.table({
      error: "FORMID SHOULD ALWAYS BE ARRAY",
    });
  }

  return returnBool;
};
const removeForms = ({ formids, qf, demandedActions }) => {
  // let formsAndNodes = [];
  let allFormIdsThatAreRemoved = [];

  formids.forEach((formid) => {
    // form-remove-policy: If the form is already added by multiple questions,
    //                     form should not be removed
    //                     How to implement form-remove-policy?
    //                        Gather every formstate lastActions' addForms array
    //                        If that array contains this formid more than once
    //                        then abort its deletion.
    if (shouldFormBeRemoved({ qf: { ...qf }, formid, demandedActions })) {
      if (!_.isEmpty(qf.formstate[formid])) {
        if (!_.isEmpty(qf.formstate[formid].nodesorder)) {
          qf = removeNodesAndUndoLastAction({
            formid,
            qf,
            nodeids: qf.formstate[formid].nodesorder,
            undoLastActionsRescursively,
          });
          allFormIdsThatAreRemoved.push(formid);
          // formsAndNodes.push({ formid, nodeids: qf.formstate[formid].nodesorder});
        }
      }
    }
  });

  qf.formsorder = _.difference(qf.formsorder, allFormIdsThatAreRemoved);

  let newFormState = {};

  qf.formsorder.forEach((formid) => {
    newFormState[formid] = qf.formstate[formid];
  });
  newFormState.currentnode = qf.formstate.currentnode;

  if (qf.prospectid) qf.formstate = newFormState;

  return qf;
};

const createLocationFormstateForFirstTime = ({
  currentformstate,
  groupstable,
  questiontable,
  calculatedverticalid,
  operations,
  formid,
}) => {
  let newFormState = {};

  newFormState = { ...currentformstate };

  newFormState.locationsorder = [1];

  newFormState.locationstate = {};

  newFormState = updateLocationStateAsPerLocationsOrder({
    formstate: { ...newFormState },
    groupstable,
    formid,
    calculatedverticalid,
    operations,
    questiontable,
    FormProperties,
  });

  // console.log(
  //   "show me the new form for location",
  //   newFormState.locationstate[1]
  // );

  return newFormState;
};

const createMasterGroupFormstateForFirstTime = ({
  currentformstate,
  groupstable,
  questiontable,
  calculatedverticalid,
  operations,
  formid,
  prevappanswers,
  triagedata
}) => {
  let newFormState = { ...currentformstate };

  newFormState.groupsorder = getFilteredGroupsUnderForm({
    calculatedverticalid,
    operations,
    groupstable,
    formid,
    triagedata
  })
    .map((group) => group.id)
    .sort();

  newFormState.groupstate = {};

  let formstateAndQuestionTableInObject = updateGroupStateAsPerGroupsOrder({
    formstate: { ...newFormState },
    groupTableInObjectForm: groupstable,
    formid,
    questiontable,
    calculatedverticalid: calculatedverticalid || 0,
    operations: operations || [],
    triagedata
  });

  newFormState = formstateAndQuestionTableInObject.formstate;

  let questionInObjectForAllGroups =
    formstateAndQuestionTableInObject.questionInObjectForAllGroups;

  newFormState = FormProperties({
    formtype: newFormState.type,
  }).updateNodesOrder({ formstate: { ...newFormState } });

  if (!newFormState.nodestate) {
    newFormState.nodestate = {};
  }
  // pass in relevant previous answers if exists

  newFormState = FormProperties({
    formtype: newFormState.type,
  }).updateNodeStateUsingNodesOrder({
    formstate: { ...newFormState },
    formid,
    formtype: newFormState.type,
    questionTableInObjectForm: questionInObjectForAllGroups,
    prevappanswers
  });

  // finally add currentnode as first nodesorder from nodestate
  if (!_.isEmpty(newFormState.nodesorder)) {
    newFormState.currentnode =
      newFormState.nodestate[newFormState.nodesorder[0]];
  }

  return newFormState;
};

const createOperationFormstateForFirstTime = ({
  currentformstate,
  groupstable,
  questiontable,
  calculatedverticalid,
  operations,
  formid,
  prevappanswers,
}) => {
  let newFormState = {
    ...createMasterGroupFormstateForFirstTime({
      currentformstate,
      groupstable,
      questiontable,
      calculatedverticalid,
      operations,
      formid,
      prevappanswers,
    }),
  };

  // A function which takes operations, and return updated groupsorder

  newFormState = updateGroupsOrderAndStateAsPerOperations({
    formstate: { ...newFormState },
    calculatedverticalid,
    operations,
    questiontable,
  });

  newFormState = updateOperationNodesOrderAndNodeStateAsPerGroups({
    formstate: { ...newFormState },
    questiontable,
    operations,
  });

  return newFormState;
};

const demistifyLocationNodeId = ({ nodeid }) => {
  let nodeidarray = nodeid.split("_");

  return {
    locationid: Number(nodeidarray[1]),
    questionid: nodeidarray[2],
  };
};

// this function is important for STI PDF ready
const MasterGroupConvertFormStateToFormGroupNodesArray = ({ formstate }) => {
  // the formstate here is the inidividual formstate

  // dig into groupstates this formstate

  let arrayToReturn = [];

  let { groupsorder, groupstate, text, type, id } = formstate;

  // pushing the form itself
  arrayToReturn.push({
    type: PossibleArrayTypesForFormGroupNodeArray.form,
    formstateAddress: {
      formid: id,
    },
    text,
  });

  if (groupsorder) {
    groupsorder.forEach((groupid) => {
      let grouptext = groupstate[groupid].text;
      let { questionsorder } = groupstate[groupid];

      arrayToReturn.push({
        type: PossibleArrayTypesForFormGroupNodeArray.group,
        formstateAddress: {
          formid: id,
          groupid,
        },
        text: grouptext,
      });

      questionsorder.forEach((questionid) => {
        let nodeid = FormProperties({ formtype: type }).getNodeId({
          questionid,
        });
        arrayToReturn.push({
          type: PossibleArrayTypesForFormGroupNodeArray.node,
          formstateAddress: {
            formid: id,
            groupid,
            questionid,
            nodeid,
          },
          node: formstate.nodestate[nodeid],
        });
      });
    });
  }

  return arrayToReturn;
};

const LocationGroupConvertFormStateToFormGroupNodesArray = ({ formstate }) => {
  // the formstate here is the inidividual formstate

  // dig into groupstates this formstate

  let arrayToReturn = [];

  let { locationsorder, locationstate, text, type, id } = formstate;
  let BrokerInfo = useSelector(getBrokerInformation);
  const languagepreference = BrokerInfo.information.languagepreference;

  // pushing the form itself
  arrayToReturn.push({
    type: PossibleArrayTypesForFormGroupNodeArray.form,
    formstateAddress: {
      formid: id,
    },
    text,
  });

  if (locationsorder) {
    locationsorder.forEach((locationid) => {
      let locationtext = `${translations[languagepreference].locationNumber}${locationid}`;
      let { groupsorder, groupstate } = locationstate[locationid];

      arrayToReturn.push({
        type: PossibleArrayTypesForFormGroupNodeArray.location,
        formstateAddress: {
          formid: id,
          locationid,
        },
        text: locationtext,
      });

      if (groupsorder) {
        groupsorder.forEach((groupid) => {
          let grouptext = groupstate[groupid].text;
          let { questionsorder } = groupstate[groupid];

          arrayToReturn.push({
            type: PossibleArrayTypesForFormGroupNodeArray.locationgroup,
            formstateAddress: {
              formid: id,
              groupid,
              locationid,
            },
            text: grouptext,
          });

          questionsorder.forEach((questionid) => {
            let nodeid = FormProperties({ formtype: type }).getNodeId({
              questionid,
              locationid,
            });
            arrayToReturn.push({
              type: PossibleArrayTypesForFormGroupNodeArray.node,
              formstateAddress: {
                formid: id,
                groupid,
                questionid,
                nodeid,
              },
              node: formstate.nodestate[nodeid],
            });
          });
        });
      }
    });
  }

  return arrayToReturn;
};

const getNextGroupFirstNodeForMasterGroup = ({ formstate, currentgroupid }) => {
  try {
    let groupIdIndex = formstate.groupsorder.indexOf(currentgroupid);
    let nextGroupId = formstate.groupsorder[groupIdIndex + 1];
    if (nextGroupId) {
      let questionid = formstate.groupstate[nextGroupId].questionsorder[0];
      let nodeid = null;
      if (questionid) {
        nodeid = MasterGroupFormProperties.getNodeId({ questionid });
        let node = formstate.nodestate[nodeid];
        if (node) return node;
        return null;
      }
    }
    return null;
  } catch (e) {
    return null;
  }
};
const getPreviousGroupFirstNodeForMasterGroup = ({
  formstate,
  currentgroupid,
}) => {
  try {
    let groupIdIndex = formstate.groupsorder.indexOf(currentgroupid);
    let previousGroupId = formstate.groupsorder[groupIdIndex - 1];
    if (previousGroupId) {
      let questionid = formstate.groupstate[previousGroupId].questionsorder[0];
      let nodeid = null;
      if (questionid) {
        nodeid = MasterGroupFormProperties.getNodeId({ questionid });
        let node = formstate.nodestate[nodeid];
        if (node) return node;
        return null;
      }
    }
    return null;
  } catch (e) {
    return null;
  }
};

/////Location start
const getLocationState = (formstate, locationid, isBuilding, buildingIndex) => {
  if (isBuilding) {
    return formstate.locationstate[locationid].buildings[buildingIndex]
      .groupstate;
  } else {
    return formstate.locationstate[locationid];
  }
};

const getNextLocationFirstNode = ({
  formstate,
  currentlocationid,
  currentBuildingId = null,
}) => {
  // console.log(
  //   " getNextLocationFirstNode we need to see currentBuilding",
  //   currentBuildingId
  // );
  try {
    let locationIdIndex = formstate.locationsorder.indexOf(
      Number(currentlocationid)
    );
    //
    //
    let nextLocationId = Number(currentlocationid);

    if (formstate.locationstate[nextLocationId].buildings) {
      let buildingIdIndex =
        currentBuildingId !== null && currentBuildingId !== ""
          ? currentBuildingId + 1
          : 0;

      // If no more buildings in current location, move to next location
      if (
        buildingIdIndex >=
        formstate.locationstate[nextLocationId].buildings.length
      ) {
        //
        locationIdIndex++;
        //
        nextLocationId = formstate.locationsorder[locationIdIndex];
        buildingIdIndex = 0; // reset building index for the new location
      }

      if (!nextLocationId || !formstate.locationstate[nextLocationId]) {
        return null;
      }

      let building =
        formstate.locationstate[nextLocationId].buildings[buildingIdIndex];

      if (!building) return null; // if building doesn't exist

      let groupid = building.groupsorder[0];
      let questionid = building.groupstate[groupid].questionsorder[0];

      let nodeid = null;
      if (questionid) {
        nodeid = LocationFormProperties.getNodeId({
          questionid,
          locationid: nextLocationId,
          buildingid: buildingIdIndex,
        });
      }

      if (nodeid) return formstate.nodestate[nodeid];
      return null;
    }
    // Fall back to old structure
    else {
      nextLocationId = formstate.locationsorder[locationIdIndex + 1];
      if (!nextLocationId) return null;

      let groupid = formstate.locationstate[nextLocationId].groupsorder[0];
      let questionid =
        formstate.locationstate[nextLocationId].groupstate[groupid]
          .questionsorder[0];

      let nodeid = null;
      if (questionid) {
        nodeid = LocationFormProperties.getNodeId({
          questionid,
          locationid: nextLocationId,
        });
      }
      if (nodeid) return formstate.nodestate[nodeid];
      return null;
    }
  } catch (e) {
    return null;
  }
};
const getPreviousLocationFirstNode = ({
  formstate,
  currentlocationid,
  currentBuildingId = null,
}) => {
  // console.log(
  //   "getPreviousLocationFirstNode we need to see currentBuilding",
  //   currentBuildingId
  // );
  try {
    let locationIdIndex = formstate.locationsorder.indexOf(
      Number(currentlocationid)
    );
    //
    //

    let previousLocationId = Number(currentlocationid);

    if (locationIdIndex > 0) {
      // Go to previous location
      locationIdIndex--;
      previousLocationId = formstate.locationsorder[locationIdIndex];

      if (!previousLocationId || !formstate.locationstate[previousLocationId]) {
        return null;
      }

      let buildings = Object.keys(
        formstate.locationstate[previousLocationId].buildings
      );
      let buildingIdIndex =
        buildings.length > 0 ? buildings[buildings.length - 1] : null;

      let building =
        formstate.locationstate[previousLocationId].buildings[buildingIdIndex];

      if (!building) return null; // if building doesn't exist

      let groupid = building.groupsorder[0];
      let questionid = building.groupstate[groupid].questionsorder[0];

      let nodeid = null;
      if (questionid) {
        nodeid = LocationFormProperties.getNodeId({
          questionid,
          locationid: previousLocationId,
          buildingid: buildingIdIndex,
        });
      }

      if (nodeid) return formstate.nodestate[nodeid];
      return null;
    }
    // Fall back to old structure or first location
    else {
      //
      return null;
    }
  } catch (e) {
    return null;
  }
};

const getNextGroupFirstNodeForLocation = ({
  formstate,
  currentlocationid,
  currentgroupid,
  currentBuildingId = null,
}) => {
  try {
    let groupsorder;
    let buildingIds = Object.keys(
      formstate.locationstate[Number(currentlocationid)].buildings
    );

    let atLastLocation =
      Number(formstate.locationsorder[formstate.locationsorder.length - 1]) ===
      Number(currentlocationid);

    let atLastBuildingAtLastQuestion = false;

    let currentBuildingIndex = buildingIds.indexOf(currentBuildingId);

    if (
      currentBuildingId !== null &&
      formstate.locationstate[Number(currentlocationid)].buildings &&
      currentBuildingId !== ""
    ) {
      // New structure (with buildings)
      groupsorder =
        formstate.locationstate[Number(currentlocationid)].buildings[
          currentBuildingId
        ].groupsorder;

      if (
        buildingIds[buildingIds.length - 1] == currentBuildingId &&
        groupsorder[groupsorder.length - 1] == currentgroupid
      ) {
        atLastBuildingAtLastQuestion = true;

        groupsorder =
          formstate.locationstate[Number(currentlocationid)].groupsorder;
      }
    } else {
      // Fall back to old structure
      groupsorder =
        formstate.locationstate[Number(currentlocationid)].groupsorder;
    }

    let groupIdIndex = groupsorder.indexOf(currentgroupid);

    let nextGroupId = groupsorder[groupIdIndex + 1];

    if (nextGroupId) {
      let nextGroupState;

      if (
        currentBuildingId !== null &&
        formstate.locationstate[Number(currentlocationid)].buildings &&
        currentBuildingId !== ""
      ) {
        // New structure (with buildings)
        nextGroupState =
          formstate.locationstate[Number(currentlocationid)].buildings[
            currentBuildingId
          ].groupstate[nextGroupId];

        if (atLastBuildingAtLastQuestion) {
          nextGroupState =
            formstate.locationstate[Number(currentlocationid)].groupstate[
              nextGroupId
            ];
        }
      } else {
        // Fall back to old structure
        nextGroupState =
          formstate.locationstate[Number(currentlocationid)].groupstate[
            nextGroupId
          ];
      }

      let questionid = nextGroupState.questionsorder[0];
      let nodeid = null;
      if (questionid) {
        nodeid = LocationFormProperties.getNodeId({
          questionid,
          locationid: atLastBuildingAtLastQuestion
            ? Number(currentlocationid) + 1
            : Number(currentlocationid),
          buildingid: atLastBuildingAtLastQuestion ? "" : currentBuildingId,
        });

        if (atLastBuildingAtLastQuestion && atLastLocation) {
          // console.log(
          //   "getNextGroupFirstNodeForLocation final rest  should be null"
          // );
          return null;
        }
        if (nodeid) return formstate.nodestate[nodeid];
      }
      return null;
    }
    return null;
  } catch (e) {
    return null;
  }
};

////Location end

const getPreviousGroupFirstNodeForLocation = ({
  formstate,
  currentlocationid,
  currentgroupid,
  currentBuildingId = null,
}) => {
  try {
    let groupsorder;
    let buildingIds = Object.keys(
      formstate.locationstate[Number(currentlocationid)].buildings
    );

    let atFirstLocation =
      Number(formstate.locationsorder[0]) === Number(currentlocationid);

    let atFirstBuildingAtFirstQuestion = false;

    let currentBuildingIndex = currentBuildingId;

    if (
      currentBuildingId !== null &&
      formstate.locationstate[Number(currentlocationid)].buildings &&
      currentBuildingId !== ""
    ) {
      // New structure (with buildings)
      groupsorder =
        formstate.locationstate[Number(currentlocationid)].buildings[
          currentBuildingId
        ].groupsorder;

      if (
        buildingIds[0] == currentBuildingId &&
        groupsorder[0] == currentgroupid
      ) {
        atFirstBuildingAtFirstQuestion = true;

        groupsorder =
          formstate.locationstate[Number(currentlocationid)].groupsorder;
      }
    } else {
      // Fall back to old structure
      groupsorder =
        formstate.locationstate[Number(currentlocationid)].groupsorder;
    }

    let groupIdIndex = groupsorder.indexOf(currentgroupid);

    /// everything above is current
    let previousGroupId =
      groupIdIndex > 0 ? groupsorder[groupIdIndex - 1] : null;

    // figure out what is the prev building last question is
    if (!previousGroupId && !atFirstBuildingAtFirstQuestion) {
      currentBuildingIndex = currentBuildingId - 1;
      groupsorder =
        formstate.locationstate[Number(currentlocationid)].buildings[
          currentBuildingIndex
        ].groupsorder;

      //set the last group in the prev building question
      groupIdIndex = groupsorder.indexOf(groupsorder[groupsorder.length - 1]);

      previousGroupId = groupIdIndex > 0 ? groupsorder[groupIdIndex] : null;
    }

    let currentLocationIndex = Number(currentlocationid) - 1;
    // this will set prev to location if at the end of line
    if (!previousGroupId && atFirstBuildingAtFirstQuestion) {
      groupIdIndex = groupsorder.indexOf(groupsorder[groupsorder.length - 1]);

      previousGroupId = groupIdIndex > 0 ? groupsorder[groupIdIndex] : null;
    }

    let atFirstLocationAtFirstQuestion;

    if (atFirstBuildingAtFirstQuestion) {
    }

    if (previousGroupId) {
      let previousGroupState;

      if (
        currentBuildingId !== null &&
        formstate.locationstate[Number(currentlocationid)].buildings &&
        currentBuildingId !== ""
      ) {
        // New structure (with buildings)
        previousGroupState =
          formstate.locationstate[Number(currentlocationid)].buildings[
            currentBuildingIndex
          ].groupstate[previousGroupId];

        if (atFirstBuildingAtFirstQuestion) {
          previousGroupState =
            formstate.locationstate[Number(currentlocationid)].groupstate[
              previousGroupId
            ];
        }
      } else {
        // Fall back to old structure
        previousGroupState =
          formstate.locationstate[Number(currentlocationid)].groupstate[
            previousGroupId
          ];
      }

      let questionid = previousGroupState.questionsorder[0];
      let nodeid = null;
      if (questionid) {
        nodeid = LocationFormProperties.getNodeId({
          questionid,
          locationid: currentlocationid,
          buildingid: atFirstBuildingAtFirstQuestion
            ? ""
            : currentBuildingIndex,
        });

        if (
          atFirstBuildingAtFirstQuestion &&
          atFirstLocation &&
          nodeid.includes("building")
        ) {
          return null;
        }

        if (nodeid) return formstate.nodestate[nodeid];
      }

      return null;
    }

    return null;
  } catch (e) {
    return null;
  }
};

////Location End
const getNextNodeOnNextClickMasterGroup = ({ formstate, currentnode }) => {
  // this function will either return a node or null if it does not have next
  return getNextGroupFirstNodeForMasterGroup({
    formstate,
    currentgroupid: currentnode.groupid,
  });
};

const getPreviousNodeOnPreviousClickMasterGroup = ({
  formstate,
  currentnode,
}) => {
  // this function will either return a node or null if it does not have next
  return getPreviousGroupFirstNodeForMasterGroup({
    formstate,
    currentgroupid: currentnode.groupid,
  });
};

const getNextNodeOnNextClickLocation = ({ formstate, currentnode }) => {
  let { locationid, groupid, buildingid } = currentnode;

  let x = getNextGroupFirstNodeForLocation({
    formstate,
    currentlocationid: locationid,
    currentgroupid: groupid,
    currentBuildingId: buildingid,
  });

  if (x) return x;

  let y = getNextLocationFirstNode({
    formstate,
    currentlocationid: locationid,
    currentBuildingId: buildingid,
  });

  if (y) return y;

  return null;
};

const getPreviousNodeOnPreviousClickLocation = ({ formstate, currentnode }) => {
  let { locationid, groupid, buildingid } = currentnode;

  let x = getPreviousGroupFirstNodeForLocation({
    formstate,
    currentlocationid: locationid,
    currentgroupid: groupid,
    currentBuildingId: buildingid,
  });

  if (x) return x;

  let y = getPreviousLocationFirstNode({
    formstate,
    currentlocationid: locationid,
    currentBuildingId: buildingid,
  });

  if (y) return y;

  return null;
};

const getFirstNodeIdFromTreeMasterGroup = ({ formstate }) => {
  try {
    let firstGroupId = formstate.groupsorder[0];
    let firstQuestionId = formstate.groupstate[firstGroupId].questionsorder[0];
    if (firstQuestionId)
      return MasterGroupFormProperties.getNodeId({
        questionid: firstQuestionId,
      });
    return null;
  } catch (e) {
    return null;
  }
};

const getFirstNodeIdFromTreeLocation = ({ formstate }) => {
  try {
    let firstLocationId = formstate.locationsorder[0];

    let firstGroupId = formstate.locationstate[firstLocationId].groupsorder[0];
    let firstQuestionId =
      formstate.locationstate[firstLocationId].groupstate[firstGroupId]
        .questionsorder[0];
    if (firstQuestionId)
      return LocationFormProperties.getNodeId({
        questionid: firstQuestionId,
        locationid: firstLocationId,
      });
    return null;
  } catch (e) {
    return null;
  }
};

// this will give last groupid or location id
const getLastParentUniquePropertiesOfLastNodeMasterGroup = ({ formstate }) => {
  try {
    let { nodesorder, nodestate } = formstate;
    let lastNodeId = nodesorder[nodesorder.length - 1];
    return { groupid: nodestate[lastNodeId].groupid };
  } catch (e) {
    return null;
  }
};
const getLastParentUniquePropertiesOfLastNodeLocation = ({ formstate }) => {
  try {
    let { nodesorder, nodestate } = formstate;
    let lastNodeId = nodesorder[nodesorder.length - 1];
    return {
      locationid: nodestate[lastNodeId].locationid,
      groupid: nodestate[lastNodeId].groupid,
    };
  } catch (e) {
    return null;
  }
};

const getParentUniquePropertiesOfFirstNodeMasterGroup = ({ formstate }) => {
  try {
    let { nodesorder, nodestate } = formstate;
    let firstNodeId = nodesorder[0];
    return { groupid: nodestate[firstNodeId].groupid };
  } catch (e) {
    return null;
  }
};
const getParentUniquePropertiesOfFirstNodeLocation = ({ formstate }) => {
  try {
    let { nodesorder, nodestate } = formstate;
    let firstNodeId = nodesorder[0];
    return {
      locationid: nodestate[firstNodeId].locationid,
      groupid: nodestate[firstNodeId].groupid,
    };
  } catch (e) {
    return null;
  }
};

const MasterGroupFormProperties = {
  updateNodesOrder: updateMGNodesOrder,
  updateNodeStateUsingNodesOrder: updateMGNodeStateUsingNodesOrder,
  getNodeId: ({ questionid }) => questionid,
  removeQuestions: removeQuestionsFromMGGroup,
  removeGroups: removeGroupsFromMGGroup,
  addQuestions: addQuestionsToMGGroup,
  addGroups: addGroupsToMGForm,
  addForms: addMGForms,
  createFormStateForFirstTime: createMasterGroupFormstateForFirstTime,
  getNextNodeOnNextClick: getNextNodeOnNextClickMasterGroup,
  getPreviousNodeOnPreviousClick: getPreviousNodeOnPreviousClickMasterGroup,
  getFirstNodeIdFromTree: getFirstNodeIdFromTreeMasterGroup,
  getLastParentUniquePropertiesOfLastNode:
    getLastParentUniquePropertiesOfLastNodeMasterGroup,
  getParentUniquePropertiesOfFirstNode:
    getParentUniquePropertiesOfFirstNodeMasterGroup,

  demistifyNodeId: ({ nodeid }) => {
    return { questionid: nodeid };
  },

  // properties for STI PDF Ready
  convertFormStateToFormGroupNodesArray:
    MasterGroupConvertFormStateToFormGroupNodesArray,
};

const OperationFormProperties = {
  updateNodesOrder: updateMGNodesOrder,
  updateNodeStateUsingNodesOrder: updateMGNodeStateUsingNodesOrder,
  getNodeId: ({ questionid }) => questionid,
  removeQuestions: removeQuestionsFromMGGroup,
  removeGroups: removeGroupsFromMGGroup,
  addQuestions: addQuestionsToOperationForm,
  addGroups: addGroupsToMGForm,
  addForms: addMGForms,
  createFormStateForFirstTime: createOperationFormstateForFirstTime,
  getNextNodeOnNextClick: getNextNodeOnNextClickMasterGroup,
  getPreviousNodeOnPreviousClick: getPreviousNodeOnPreviousClickMasterGroup,
  getFirstNodeIdFromTree: getFirstNodeIdFromTreeMasterGroup,
  getLastParentUniquePropertiesOfLastNode:
    getLastParentUniquePropertiesOfLastNodeMasterGroup,
  getParentUniquePropertiesOfFirstNode:
    getParentUniquePropertiesOfFirstNodeMasterGroup,
  demistifyNodeId: ({ nodeid }) => {
    return { questionid: nodeid };
  },

  // properties for STI PDF Ready
  convertFormStateToFormGroupNodesArray:
    MasterGroupConvertFormStateToFormGroupNodesArray,
};

const LocationFormProperties = {
  updateNodesOrder: updateLocationNodesOrder,
  updateNodeStateUsingNodesOrder: updateLocationNodeStateUsingNodesOrder,
  getNodeId: ({ questionid, locationid, buildingid }) => {
    if (typeof buildingid !== "undefined" && buildingid !== "") {
      // If buildingid is provided (indicating new structure with buildings)
      return `location_${locationid}_building_${buildingid}_${questionid}`;
    } else {
      // Fall back to old structure (just locations)
      return `location_${locationid}_${questionid}`;
    }
  },
  removeQuestions: removeQuestionsFromLocationGroup,
  removeGroups: removeGroupsFromLocationGroup,
  addQuestions: addQuestionsToLocationGroup,
  addGroups: addGroupsToLocationForm,
  addForms: addMGForms,
  createFormStateForFirstTime: createLocationFormstateForFirstTime,
  getNextNodeOnNextClick: getNextNodeOnNextClickLocation,
  getPreviousNodeOnPreviousClick: getPreviousNodeOnPreviousClickLocation,
  getFirstNodeIdFromTree: getFirstNodeIdFromTreeLocation,
  getLastParentUniquePropertiesOfLastNode:
    getLastParentUniquePropertiesOfLastNodeLocation,
  getParentUniquePropertiesOfFirstNode:
    getParentUniquePropertiesOfFirstNodeLocation,
  demistifyNodeId: demistifyLocationNodeId,

  // properties for STI PDF Ready
  convertFormStateToFormGroupNodesArray:
    LocationGroupConvertFormStateToFormGroupNodesArray,
};

export const FormProperties = ({ formtype }) => {
  if (formtype === MASTERGROUP) return MasterGroupFormProperties;
  if (formtype === OPERATION) return OperationFormProperties;
  if (formtype === LOCATION) return LocationFormProperties;

  return null;
};

//#endregion

//#region Compare screen configurations
export const getRowIdForPrice = ({ rows }) => {
  let indexI = 0;
  try {
    while (indexI < rows.length) {
      if (rows[indexI].id === getCoverIdOfPrice()) {
        return indexI;
      }
      indexI++;
    }
  } catch (e) {
    return indexI;
  }

  return indexI;
};

export const currencyFormatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  // These options are needed to round to whole numbers if that's what you want.
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});
export const coverTypeLocation = "LOCATION";
export const inputValueType = "percent2f";
//#endregion
